import type {Snapshot} from './model'
import type {ReleasesSnapshot} from '../api/releases'
import {pendingActions} from './waitingPolicy'
import {releaseNeedsOwner} from './hubReleaseProjection'
export function hubAttention(data?:Snapshot,releases?:ReleasesSnapshot){
 if(!data||!releases)return {waiting:undefined,releases:undefined}
 const waiting=new Set(data.items.filter(item=>pendingActions(item,data).length).map(item=>'item:'+item.id)),releaseAttention=new Set<string>()
 for(const pr of releases.prs){
  if(pr.state!=='open')continue
  const owner=releaseNeedsOwner(pr),approval=pr.approved_sha===pr.head_sha&&!!pr.approved_at&&Number.isFinite(Date.parse(pr.approved_at))&&['night','now','runbook'].includes(pr.approved_mode??'')
  const queued=approval||pr.auto_queued===true&&pr.auto_sha===pr.head_sha
  if(owner){const card=data.items.find(item=>item.pr_urls.includes(pr.url)||pr.task?.id===item.task_id);waiting.add(card?'item:'+card.id:'pr:'+pr.url)}
  if(owner||!queued&&!pr.blocker?.trim())releaseAttention.add(pr.url)
 }
 return {waiting:waiting.size,releases:releaseAttention.size}
}
